var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 24,
    viewBox: "0 0 226 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MANY CONSULTANCY"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79837 0.296753L9.69172 13.7991H9.8401L12.5109 0.296753H18.3347V23.6662H14.0688V9.0881H13.9205L10.99 23.6662H8.09667L5.05493 9.0881H4.90656V23.6662H0.863281V0.296753H6.79837Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2506 0.296753H29.7035L34.6741 23.6662H30.0744L29.11 18.6213H24.4732L23.5088 23.6662H19.28L24.2506 0.296753ZM26.7731 6.71406L25.1409 15.0974H28.4794L26.9214 6.71406H26.7731Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9507 12.6121V0.296753H49.2165V23.6662H45.7297L40.0172 10.0526H39.8688V23.6662H35.6029V0.296753H39.8317L44.8023 12.6121H44.9507Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8963 9.7558L60.6784 0.296753H65.2039L59.8994 15.3941V23.6662H55.4481V15.3941L50.1436 0.296753H54.8917L57.8963 9.7558Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9008 8.16074V15.8022C74.9008 18.51 75.2718 20.2164 77.0152 20.2164C78.7957 20.2164 79.0925 18.51 79.0925 15.8022V13.6878H83.5809V14.6522C83.5809 20.2535 81.9859 23.9629 77.1265 23.9629C72.0817 23.9629 70.1528 20.2906 70.1528 13.6507V10.3122C70.1528 3.67233 72.0817 0 77.1265 0C81.9859 0 83.5809 3.70943 83.5809 9.31066V10.2751H79.0925V8.16074C79.0925 5.45286 78.7957 3.74652 77.0152 3.74652C75.2718 3.74652 74.9008 5.45286 74.9008 8.16074Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5893 10.4235V13.5394C98.5893 20.1793 96.6604 23.9629 91.6527 23.9629C86.6079 23.9629 84.679 20.1793 84.679 13.5394V10.4235C84.679 3.78362 86.6079 0 91.6527 0C96.6604 0 98.5893 3.78362 98.5893 10.4235ZM89.4641 8.23493V15.728C89.4641 18.4359 89.8722 20.2164 91.6527 20.2164C93.4332 20.2164 93.8412 18.4359 93.8412 15.728V8.23493C93.8412 5.52705 93.4332 3.74652 91.6527 3.74652C89.8722 3.74652 89.4641 5.52705 89.4641 8.23493Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.467 12.6121V0.296753H113.733V23.6662H110.246L104.534 10.0526H104.385V23.6662H100.119V0.296753H104.348L109.319 12.6121H109.467Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.03 15.6167H119.111V17.0263C119.111 19.0294 119.927 20.2906 121.485 20.2906C122.894 20.2906 123.599 19.3632 123.599 17.8053C123.599 16.136 122.709 15.5425 121.299 14.6151L119.37 13.391C117.107 11.9815 115.104 10.3864 115.104 6.4915C115.104 2.5966 117.516 0 121.262 0C125.305 0 127.457 2.44822 127.457 6.93663V8.27202H123.413V6.89954C123.413 4.78516 122.746 3.67233 121.262 3.67233C119.964 3.67233 119.333 4.67388 119.333 6.19474C119.333 7.7527 120.038 8.53168 121.225 9.27357L123.339 10.609C126.047 12.204 127.865 13.8362 127.865 17.4343C127.865 21.626 125.342 23.9629 121.485 23.9629C117.553 23.9629 115.03 21.626 115.03 16.9521V15.6167Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.959 24C130.729 24 129.134 20.7357 129.134 15.9505V0.296753H133.845V16.2473C133.845 18.8068 134.216 20.2164 135.959 20.2164C137.703 20.2164 138.111 18.8068 138.111 16.2473V0.296753H142.822V15.9505C142.822 20.7357 141.189 24 135.959 24Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.567 0.296753H149.167V19.8825H155.436V23.6662H144.567V0.296753Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.698 23.6662H158.098V4.08037H153.721V0.296753H167.186V4.08037H162.698V23.6662Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.708 0.296753H176.161L181.131 23.6662H176.532L175.567 18.6213H170.93L169.966 23.6662H165.737L170.708 0.296753ZM173.23 6.71406L171.598 15.0974H174.937L173.379 6.71406H173.23Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.408 12.6121V0.296753H195.674V23.6662H192.187L186.474 10.0526H186.326V23.6662H182.06V0.296753H186.289L191.26 12.6121H191.408Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.905 8.16074V15.8022C201.905 18.51 202.276 20.2164 204.02 20.2164C205.8 20.2164 206.097 18.51 206.097 15.8022V13.6878H210.585V14.6522C210.585 20.2535 208.99 23.9629 204.131 23.9629C199.086 23.9629 197.157 20.2906 197.157 13.6507V10.3122C197.157 3.67233 199.086 0 204.131 0C208.99 0 210.585 3.70943 210.585 9.31066V10.2751H206.097V8.16074C206.097 5.45286 205.8 3.74652 204.02 3.74652C202.276 3.74652 201.905 5.45286 201.905 8.16074Z",
    fill: "#002F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.829 9.7558L220.611 0.296753H225.137L219.832 15.3941V23.6662H215.381V15.3941L210.076 0.296753H214.825L217.829 9.7558Z",
    fill: "#002F61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.d0081a23c2d39b2e77b2a8ecfc5cf5d0.svg";
export { ForwardRef as ReactComponent };